import { Dossier } from '@sc/data-access-models';

export interface PlanningFormUpdateDossierEvent {
  dossier: Dossier;
  keepFormOpen?: boolean;
  isLocal?: boolean;
  isResumed?: boolean;
}
